<template>
  <div class="service-history" v-if="machine">

    <b-modal :active.sync="showModal">
      <div class="box" v-if="selected">
        <h4 class="title is-5 no-margin pad-bottom flex">
          <div class="flex-1">Service Summary</div>
          <div class="tag" :class="selected.status === 'active' ? 'is-success' : ''">{{ selected.status }}</div>
        </h4>
        <div class="flex">
          <div class="flex-1">
            <h3 class="title is-6">Started</h3>
            <h2 class="subtitle is-6">
              {{ selected.timestampStarted | unixToDateTimeString }}, {{ selected.userStarted }}
            </h2>
          </div>
          <div class="flex-1" v-if="selected.imestampCompleted">
            <h3 class="title is-6">Completed</h3>
            <h2 class="subtitle is-6">
              {{ selected.timestampCompleted | unixToDateTimeString }}, {{ selected.userCompleted}}
            </h2>
          </div>
        </div>
        <br />
        <div class="buttons">
          <button class="button is-info" @click="showServiceDetials()">Show Details</button>
          <button class="button" @click="closeModal()">Close</button>
        </div>
      </div>
    </b-modal>

    <h1 class="title is-4 flex pad no-margin">
      <!-- <div class="flex-1 pointer" @click="$router.push(`/view-machine-services/${machine._id}`)">Service History</div> -->
      <div class="flex-1" >Service History</div>
      <button class="button is-small" @click="addService">
        <font-awesome-icon icon="plus" />
      </button>
    </h1>

    <template v-if="services === null">
      <loading />
    </template>

    <template v-else-if="services.length">
      <table class="table is-hoverable is-striped">
        <tbody>
          <tr v-for="s in services" :key="s._id" @click="showService(s)">
            <td><div class="bold">{{ s.timestampCompleted ? s.timestampCompleted : s.timestampStarted | unixToDateString }}</div></td>
            <td>{{ s.userStarted }}</td>
            <td class='text-right'>
              <b-tag :type="s.status === 'active' ? 'is-success' : ''">{{ s.status }}</b-tag>
            </td>
          </tr>
        </tbody>
      </table>
    </template>

    <template v-else>
      <div class="pad text-center has-text-grey-light">
        There are no services
        <br /><br />
      </div>
    </template>

  </div>
</template>

<script>
import { ServicesHelper } from '@/utils/services.js'
export default {
  name: 'ServiceHistory',
  props: ['machine'],
  data () {
    return {
      services: null,
      showModal: false,
      selected: null
    }
  },
  watch: {
    machine () { this.getServices() }
  },
  created () {
    this.getServices()
  },
  methods: {
    showServiceDetials () {
      this.$router.push(`/service/${this.selected._id}`)
    },
    showService (service) {
      this.selected = service
      this.showServiceDetials()
      // this.showModal = true
    },
    closeModal () {
      this.showModal = false
      this.selected = null
    },
    addService () {
      this.$dialog.confirm({
        title: `New Service`,
        message: `Begin a service for <b>${this.machine.name}</b>. ${!this.machine.serviceCheckListId ? '<p><b>WARNING:</b> No service check list set</p> ' : ''}`,
        cancelText: 'Cancel',
        confirmText: 'Start',
        type: 'is-info',
        onConfirm: this.prepareNewService
      })
    },
    prepareNewService () {
      if (!this.machine.serviceCheckListId) {
        this.submitNewService()
      } else {
        this.$firestore.collection('checkLists')
          .doc(this.machine.serviceCheckListId)
          .get()
          .then(doc => {
            let checkList = this.$utils.docToObj(doc)
            if (checkList.requiresSmu) {
              checkList.checks.unshift({
                name: 'Enter SMU ' + this.$options.filters.prettyUnits(this.machine.units),
                type: 'number',
                mandatory: true
              })
            }
            this.submitNewService(checkList)
          })
          .catch(err => {
            this.submitNewService()
            console.log('ERROR could not get service check list', err)
          })
      }
    },
    submitNewService (checkList = null) {
      let service = ServicesHelper.getBlankService(this.machine._id)
      service.checkList = checkList
      this.$firestore.collection('machineServices')
        .add(service)
        .then(resp => {
          this.$router.push(`/service/${resp.id}`)
        })
        .catch(err => {
          this.$toast.open({ message: 'ERROR could not start servce', type: 'is-danger' })
          console.log('ERROR adding service', err)
        })
    },
    getServices () {
      this.services = null
      this.unsub('machineServices')
      if (!this.machine) {
        return
      }

      this.subs.machineServices = this.$firestore.collection('machineServices')
        .where('machineId', '==', this.machine._id)
        .orderBy('timestampStarted', 'desc')
        .onSnapshot(snapshot => {
          this.services = this.$utils.snapshotToArr(snapshot)
        })
    }
  }
}
</script>

<style>
  .service-history table {
    border-top: solid 2px #ccc;
  }
</style>
